// components
export { FBCommentEmbedComponent } from './components/fb-comment-embed/fb-comment-embed';
export { FBCommentsComponent } from './components/fb-comments/fb-comments';
export { FBFollowComponent } from './components/fb-follow/fb-follow';
export { FBLikeComponent } from './components/fb-like/fb-like';
export { FBPageComponent } from './components/fb-page/fb-page';
export { FBPostComponent } from './components/fb-post/fb-post';
export { FBQuoteComponent } from './components/fb-quote/fb-quote';
export { FBSaveComponent } from './components/fb-save/fb-save';
export { FBSendComponent } from './components/fb-send/fb-send';
export { FBShareComponent } from './components/fb-share/fb-share';
export { FBVideoComponent } from './components/fb-video/fb-video';
// providers
export { FacebookService } from './providers/facebook';
// modules
export { FacebookModule } from './facebook.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-facebook/dist/esm/index.js
// module id = 1550
// module chunks = 21